/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SecurityHelper } from 'sarsaparilla';

import useLayoutSize from '../hooks/useLayoutSize';

const defaultLayoutControl = {
    isFullView: false,
    isMobileApp: false,
    isShowAvailabilityFilters: true,
    isInformationRequired: false,
    setIsFullView: () => {},
    setIsShowAvailabilityFilters: () => {},
    windowSize: 'md',
};

export const LayoutControlContext = React.createContext(defaultLayoutControl);

function DetailedAvailabilityPageLayout({
    children,
    permitName = '',
    isInformationRequired = false,
}) {
    const [isFullView, setIsFullView] = useState(false);
    const isMobileApp = SecurityHelper.isMobileApp();
    const [isShowAvailabilityFilters, setIsShowAvailabilityFilters] =
        useState(isMobileApp);
    const windowSize = useLayoutSize();

    const layoutControl = useMemo(
        () => ({
            isFullView,
            isInformationRequired,
            isMobileApp,
            isShowAvailabilityFilters,
            setIsFullView,
            setIsShowAvailabilityFilters,
            windowSize,
        }),
        [
            isFullView,
            isInformationRequired,
            isMobileApp,
            isShowAvailabilityFilters,
            setIsFullView,
            setIsShowAvailabilityFilters,
            windowSize,
        ]
    );

    return (
        <div className="per-availability-page">
            <div className="per-availability-layout per-availability-layout-new">
                <LayoutControlContext.Provider value={layoutControl}>
                    {children}
                </LayoutControlContext.Provider>
            </div>
        </div>
    );
}

DetailedAvailabilityPageLayout.propTypes = {
    children: PropTypes.node,
    permitName: PropTypes.string,
    isInformationRequired: PropTypes.bool,
};

export default DetailedAvailabilityPageLayout;
